var map = {
	"./asscher@2x.png": 306,
	"./cushion@2x.png": 307,
	"./emerald@2x.png": 308,
	"./heart@2x.png": 309,
	"./marquise@2x.png": 310,
	"./oval@2x.png": 311,
	"./pear@2x.png": 312,
	"./princess@2x.png": 313,
	"./radiant@2x.png": 314,
	"./round@2x.png": 315,
	"./trilliant@2x.png": 316
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1386;



//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images ^\.\/.*@2x\.png$
// module id = 1386
// module chunks = 0